<template>
    <main-layout>
        <div class="container">
            <H1 class="pageTitle isPoppins">Order Details</H1>

              <div class="top20 has-text-white">
                <b>Thank you for your order!</b>
              </div>

              <div class="top20 bandOrders has-background-darkTurk">
                <b class="is-size-5"><span class="has-text-yell">Don't Forget!</span> <span class="has-text-weight-normal">Assign a URL to your new Slinks and add SubSlinks!</span></b>
                  <div class="top5">Go to the <b @click="$router.push('/mng')" class="handCursor has-text-yell">Manage Services</b> page to do this.</div>
              </div>
          
              <div id="forSpinner" class="is-loading" v-if="order.createDate == ''">&nbsp;</div>
              <div id="checkoutTableDiv" class="top40 has-text-dark" v-if="order" style="display: none">
                  <div @click="hideDetail" class="is-pulled-right has-text-weight-bold has-text-light right10 top10" id="backToList">
                      &lt; Show all orders
                  </div>
                  
                  <div class="accSettingsForm has-text-white">
                    <div class="has-text-weight-bold">Date: {{az.dateConvert(order.createDate)}}</div>
                    <div class="has-text-weight-bold">Invoice ID: {{order.shortId}}</div>
                    <p>Slink, Inc<br>
                    341 Glenridge Rd<br>
                    Key Biscyane, FL 33141
                    </p>
                    <br>
                    <div class="has-text-weight-bold">Billed To:</div>
                    <div>{{order.billing.nameOnCard}}</div>
                    <div>{{order.billing.company}}</div>
                    <div>{{order.billing.address1}}</div>
                    <div v-show="order.billing.address2">{{order.billing.address2}}</div>
                    <div>{{order.billing.city}}, {{order.billing.state}} {{order.billing.zip}}</div>
                    <div>{{order.billing.country}}</div>
                    <br>
                  </div>
  
                  <div class="accSettingsForm has-text-white">
                    <table width="100%" class="bottom10">
                        <tr class="top10 has-text-weight-bold" >
                            <td width="40%">Item</td>
                            <td width="20%">Item Type</td>                      
   
                            <td width="20%" class="has-text-right">Amount</td>
                        </tr>
    
                        <tr v-for="(item, index) in this.order.data" :key="item.id" :class="{'tableDarkRow': ((index + 1) % 2)}">
                            <td><span v-if="item.type == 'slink'">&raquo;</span>{{item.slink | itemFilter}}</td>
                            <td>{{item.type | theType}}</td>                          
     
                            <td class="has-text-right">${{az.formatCurrency(item.price)}}</td>
                        </tr>
    
                        <tr class="top10 has-text-weight-bold" >
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
              
                            <td class="topLine has-text-right">${{az.formatCurrency(order.price)}}</td>
                        </tr>
                    </table>

                    <button class="button is-darkTurk" @click="$router.push('/mng')"><b>Manage your Slinks</b></button>
                  </div>
                  <br><br><br>
          </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import { AZEventBus } from '../components/AZEventBus'

export default {
  props: {id: String, serverObj: Object},
  components: {
    MainLayout
  },
  data: function () {
    var order = {createDate:'', billing: {}}

    return {
      order,
      az: az,
      inited: false,
      showAssignPrompt: false
    }
  },
  mounted: function () {
    const self = this
    function worked(data) {
      self.order = data.Item;
      document.getElementById('checkoutTableDiv').style.display = 'block';
    }
    function noWorked() {
      self.$root.showModalOK({message: 'There was en error loading the order.'})
    }

    function init(){
      self.inited = true
      if(self.serverObj == undefined && self.id){
        self.$root.apiClient.get('api/account/order/' + self.id, {}, worked, noWorked);
        self.showAssignPrompt = true
      } else {
        self.order = self.serverObj;
        document.getElementById('checkoutTableDiv').style.display = 'block';
        history.replaceState({}, "Order Details", "orderdetails/" + self.order.itemId);
       
      }
    }

    if(self.$root.doneFederating){
      init();
    }

    AZEventBus.$once('onFederate', msg => {
      if(self.inited == false)
            init();
    });
    
  },
  methods:{
      hideDetail: function(){
        this.$router.push('/orders');
      }
  },
  filters:{
     theType:  function(val){
      if(val == 'subPack')
        return 'SubPack'
      else if(val == 'trialconv')
        return 'slink'
      else
        return val
    },
    itemFilter: function(val){
      let arr = val.split('|')
      if(arr.length > 1 && arr[1] != 'conversion'){
        return "Subpack for '" + arr[0] + "'"
      } else if(arr[1] == 'conversion'){
        return arr[0]
      } else {
        return val
      }
    }
  }
}
</script>

<style scoped>
    #forSpinner{
      min-height: 300px;
    }
    #backToList{
        cursor: pointer;
        color: #666;
    }
    #backToList:hover{
        color: #888;
    }
</style>



// WEBPACK FOOTER //
// src/pages/OrderDetails.vue